module.exports = __webpack_public_path__ + "static/profile-2ef6d194c78b58e51589aa0701d63633.png";